<template>
  <div>
    <v-container fluid>
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" md="6">
              <h1 style="font-weight: 600; font-size: 28px;" class="mr-4">{{ $t('modelQuickReply') }}</h1>
            </v-col>
            <v-col cols="12" md="6" class="d-flex flex-wrap justify-end gap-2">
              <div class="custom-search-input-wrapper">
                <div class="custom-search-input-container">
                  <v-icon class="custom-search-input-icon">mdi-magnify</v-icon>
                  <input id="modelgroup-field-search-setupgroupmodel" type="text" :placeholder="$t('quickReplyGroupName')"
                    :aria-label="$t('quickReplyGroupName')"
                    class="custom-search-input" v-model="searchName" @keydown.enter="Search" />
                  <v-icon class="clear-icon" :style="searchName ? '' : 'color: transparent !important;'"
                    @click="searchName = ''">
                    mdi-close-circle
                  </v-icon>
                </div>
              </div>
              <v-btn
                id="button-add-popupadd-modelquickgroup"
                color="primary"
                class="control-btn create-btn customadd"
                variant="flat"
                size="large"
                prepend-icon="mdi-plus"
                rounded="xl"
                @click="Add()"
              >
                {{ $t("add") }}
                <v-tooltip activator="parent" location="top">{{ $t('addQuickReply') }}</v-tooltip>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table-server
          :items-per-page="options.itemsPerPage"
          :items-length="searchTotalTable"
          v-model:options="options"
          :items="menus"
          :headers="headers"
          :loading="loadingTable"
          class="pa-5"
        >
          <template v-slot:item="{ item,index }">
            <tr>
              <td style="text-align: center">{{ (options.page - 1) * options.itemsPerPage + index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td style="text-align: left">
                <ModelChipsCell :model-name-table="item.modelNameTable" />
              </td>
              <td style="text-align: center">
                <div class="action-group" style="justify-content: center;">
                  <!-- View Details -->
                  <v-btn icon variant="text" density="comfortable"
                    v-show="item.modelNameTable != 'All Model' && item.modelNameTable != ''" @click="Detail(item)"
                    class="detail-btn">
                    <v-img :src="images.viewdetailImg" width="23" height="23"></v-img>
                    <v-tooltip activator="parent" location="top">
                      {{ $t('viewDetails') }}
                    </v-tooltip>
                  </v-btn>
                  <!-- Edit -->
                  <v-btn
                    id="button-edit-popupedit-modelquickreply"
                    variant="text"
                    density="comfortable"
                    @click="Edit(item)"
                    class="action-btn edit-btn"
                    icon
                  >
                    <v-img :src="images.editBtn" width="23" height="23"></v-img>
                    <v-tooltip activator="parent" location="top">
                      {{ $t('edit') }}
                    </v-tooltip>
                  </v-btn>             
                  <!-- Delete -->
                  <v-btn
                    id="button-delete-popupdelete-modelquickreply"
                    variant="text"
                    density="comfortable"
                    @click="DeleteGroup(item.modelQuickGroupID)"
                    class="action-btn delete-btn"
                    icon
                  >
                    <v-img :src="images.deleteBtn" width="23" height="23"></v-img>
                    <v-tooltip activator="parent" location="top">
                      {{ $t('delete') }}
                    </v-tooltip>
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
          <!-- 👇 Custom footer area -->
          <template v-slot:bottom>
            <div class="d-flex justify-space-between align-center px-4 py-2" style="width: 100%">
              <div>{{ $t('totalResults') }} {{ searchTotalTable }}</div>

              <v-data-table-footer v-model:items-per-page="itemsPerPage" :page="options.page"
                :length="Math.ceil(searchTotalTable / itemsPerPage)" />
            </div>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>
    <!-- Loading Please Wait... -->
    <LoadingOverlay :model-value="loading" />
    <!-- Edit -->

    <!-- Edit -->
    <!-- Add / Edit Dialog (merged; mode driven by Adddialog vs Editdialog to remove duplicated template) -->
    <v-dialog v-model="quickReplyDialog" max-width="1200px" persistent scrollable class="modern-dialog">
      <v-card class="dialog-card">
        <!-- Header -->
        <div class="dialog-header dialog-header-add">
          <div class="header-main">
            <div class="header-text-content">
              <div class="title-with-chip">
                <h2 class="dialog-title">{{ Adddialog ? $t('addQuickReplyGroup') : $t('editQuickReplyGroup') }}</h2>
                <v-chip v-if="GroupModel.Model && GroupModel.Model.length > 0" size="small" variant="tonal" color="info"
                  class="summary-chip">
                  <span v-if="GroupModel.isAllModel">{{ $t('allModelsIncluded') }}</span>
                  <span v-else>{{ $t('_commandsConfigured', { count: GroupModel.Model.length }) }}</span>
                </v-chip>
              </div>
              <p class="dialog-subtitle">{{ $t('_createModelShortcutGroup') }}</p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn icon variant="text" @click="quickReplyDialog = false" class="close-button">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
        
        <!-- Content -->
        <v-card-text class="dialog-content">
          <div class="form-container">
            <!-- Basic Information Section -->
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title d-flex align-center"> <v-img :src="images.basicInfo" width="20" height="20"
                    class="mr-3"></v-img> {{ $t('basicInformation') }}</h3>
              </div>
              
              <v-row>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <div class="input-label">
                      <span>{{ $t('quickReplyGroupName') }}</span>
                      <span class="required-asterisk">*</span>
                      <InfoTooltip :text="$t('_quickReplyGroupNameTooltip')"
                        size="small" color="grey-darken-1" icon-class="help-icon help-icon-accent" location="top" max-width="300px" />
                    </div>
                    
                    <v-text-field
                      :id="'quickreplygroupname-field-popup' + (Adddialog ? 'add' : 'edit') + '-modelquickreply'"
                      v-model="GroupModel.Name"
                      :rules="[rules.required]"
                      variant="outlined"
                      density="comfortable"
                      :placeholder="$t('_enterGroupName')"
                      hide-details="auto"
                      class="modern-input"
                    />
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-label">
                      <span>{{ $t('importFromShortcut') }}</span>
                      <InfoTooltip :text="$t('_importFromShortcutTooltip')"
                        size="small" color="grey-darken-1" icon-class="help-icon help-icon-accent" location="top" max-width="300px" />
                    </div>
                  <div class="input-wrapper">
                <v-autocomplete
                  :id="'shortcutgroup-autocomplete-popup' + (Adddialog ? 'add' : 'edit') + 'import-modelquickreply'"
                  :items="filteredQuickGroup"
                  v-model="importData"
                  item-title="name"
                  item-value="modelQuickGroupID"
                  variant="outlined"
                  density="comfortable"
                  clearable
                  class="modern-input import-autocomplete"
                  hide-details="auto"
                  :placeholder="$t('_selectShortcutGroup')"
                  @update:model-value="handleImportSelection"
                >
                  <template v-slot:item="{ props, item, index }">
                    <v-list-item 
                      v-bind="props"
                      :id="'shortcutgroup-import-modelquickreply-option-' + index" 
                      :value="item.raw.name"
                    >
                      <template v-slot:title>
                        <span>{{ item.raw.name }}</span>
                      </template>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </div>
                </v-col>
              </v-row>
            </div>
          </div>
          <div class="form-container mt-5">
            <!-- Model Configuration Section -->
            <div class="form-section">
                <div class="section-header">
                  <h3 class="section-title d-flex align-center"> <v-img :src="images.modelSetup" width="20" height="20"
                      class="mr-3"></v-img> {{ $t('modelSetup') }}</h3>
                  <v-chip
                    v-if="GroupModel.Model && GroupModel.Model.length > 0"
                    size="small"
                    variant="tonal"
                    color="info"
                    class="summary-chip ml-3"
                  >
                    {{ GroupModel.Model.length }} {{ $t(GroupModel.Model.length === 1 ? 'model' : 'models') }}
                  </v-chip>
                  <v-spacer></v-spacer>
                      <div class="checkbox-wrapper">
                        <v-checkbox
                          :id="'allmodel-checkbox-popup' + (Adddialog ? 'add' : 'edit') + '-modelquickreply'"
                          v-model="GroupModel.isAllModel"
                          color="#C32E0E"
                          hide-details
                          @update:model-value="clearModel"
                          density="comfortable"
                          class="modern-checkbox"
                        >
                          <template v-slot:label>
                            <div class="checkbox-label">
                              <span>{{ $t('addAllModels') }}</span>
                            </div>
                          </template>
                        </v-checkbox>
                      </div>
                </div>
              <!-- Models Table -->
              <div class="table-container" v-if="!GroupModel.isAllModel">
                <v-table class="modern-table" density="compact">
                  <thead>
                    <tr>
                      <th scope="col" class="table-header">#</th>
                      <th scope="col" class="table-header model-col">{{ $t('modelName') }}
                        <InfoTooltip :text="$t('_chooseModelsForQuickReply')"
                          size="small" color="grey-darken-1" icon-class="" location="top" max-width="300px" />
                      </th>
                      <th scope="col" class="table-header actions-col" style="text-align: center;">{{ $t('actions') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in GroupModel.Model"
                      :key="index"
                      class="table-row"
                    >
                      <td class="table-cell number-cell">{{ index + 1 }}</td>
                      
                      <td class="table-cell model-cell">
                        <v-autocomplete
                          :id="'model-autocomplete-popup' + (Adddialog ? 'add' : 'edit') + '-modelquickreply-' + index"
                          :disabled="GroupModel.isAllModel"
                          :placeholder="$t('selectModel')"
                          v-model="item.modelID"
                          :items="filteredModels(index)"
                          item-title="name"
                          item-value="modelDisplayID"
                          hide-details
                          clearable
                          variant="outlined"
                          density="compact"
                          class="table-autocomplete"
                        >
                          <template v-slot:item="{ props, item, index }">
                            <v-list-item 
                              v-bind="props"
                              :id="'model-' + (Adddialog ? 'add' : 'edit') + '-modelquickreply-option-' + index"
                              :value="item.raw.name"
                            >
                              <template v-slot:title>
                                <span>{{ item.raw.name }}</span>
                              </template>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                      </td>
                      
                      <td class="table-cell actions-cell">
                        <div class="action-buttons">
                          <v-btn
                            :id="Adddialog ? null : ('button-deleterowmodel1-popupedit-modelquickreply-' + index)"
                            :disabled="index == 0 && GroupModel.Model.length == 1"
                            icon
                            variant="text"
                            size="small"
                            color="error"
                            class="actionbtns removebtns mr-4"
                            @click="Minus_ModelQuick(index)"
                          >
                            <v-icon :size="Adddialog ? 30 : undefined">mdi-minus</v-icon>
                            <v-tooltip activator="parent" location="top">
                              {{ Adddialog ? $t('removeModel') : $t('removeCommand') }}
                            </v-tooltip>
                          </v-btn>
                          <v-btn
                            :id="'button-addrowmodel1-popup' + (Adddialog ? 'add' : 'edit') + '-modelquickreply-' + index"
                            icon
                            variant="text"
                            size="small"
                            color="success"
                            class="actionbtns addbtn"
                            @click="Plus_ModelQuick(index)"
                          >
                            <v-icon :size="Adddialog ? 30 : undefined">mdi-plus</v-icon>
                            <v-tooltip activator="parent" location="top">
                              {{ Adddialog ? $t('addModel') : $t('addCommand') }}
                            </v-tooltip>
                          </v-btn>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </v-table>
              </div>
              <!-- All Model Info -->
              <div v-else-if="Adddialog" class="form-section">
                <div class="all-model-info">
                  <h3 class="info-title"><v-icon size="20" color="success" class="mr-1">mdi-check-circle-outline</v-icon>{{ $t('_allModelsIncludedTitle') }}</h3>
                  <p class="info-subtitle">{{ $t('_groupAutoIncludesAllModels') }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="form-container mt-5">
            <!-- Quick Reply Commands Section -->
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title d-flex align-center"> <v-img :src="images.quickReply" width="20" height="20"
                    class="mr-3"></v-img> {{ $t("quickReplyCommand") }}</h3>
                    <InfoTooltip :text="$t('_configureQuickReplyCommands')"
                      size="small" color="grey-darken-1" icon-class="help-icon help-icon-accent mr-2" location="top" max-width="300px" />
                <v-chip
                  v-if="GroupModel.commandList && GroupModel.commandList.length > 0"
                  size="small"
                  variant="tonal"
                  color="info"
                  class="summary-chip ml-3"
                >
                  {{ GroupModel.commandList.length }} {{ $t(GroupModel.commandList.length === 1 ? 'command' : 'commands') }}
                </v-chip>
              </div>
            </div>
            <!-- Quick Reply Commands Table -->
              <div class="table-container">
                <v-table class="modern-table" density="compact">
                  <thead>
                    <tr>
                      <th scope="col" class="table-header">#</th>
                      <th scope="col" class="table-header">{{ $t("Label") }}
                        <InfoTooltip :text="$t('_nameOfQuickReply')"
                          size="small" color="grey-darken-1" icon-class="" location="top" max-width="300px" />
                      </th>
                      <th scope="col" class="table-header">{{ $t("Message") }}
                        <InfoTooltip :text="$t('_replyTextSentToChat')"
                          size="small" color="grey-darken-1" icon-class="" location="top" max-width="300px" />
                      </th>
                      <th scope="col" class="table-header">{{ $t("Type") }}
                        <InfoTooltip size="small" color="grey-darken-1" icon-class="" location="top" max-width="300px">
                          <span>{{ $t('_postbackTypeDesc') }}
                            <br />{{ $t('_messageTypeDesc') }}
                          </span>
                        </InfoTooltip>
                      </th>
                      <th scope="col" class="table-header" style="text-align: center;">{{ $t("UploadImage") }}
                        <InfoTooltip :text="$t('_selectIconForReply')"
                          size="small" color="grey-darken-1" icon-class="" location="top" max-width="300px" />
                      </th>
                      <th scope="col" class="table-header" style="text-align: center; min-width: 150px;">{{ $t('IconPreview') }}</th>
                      <th scope="col" class="table-header actions-col" style="text-align: center;">{{ $t('actions') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in GroupModel.commandList"
                      :key="index"
                      class="table-row"
                    >
                      <td class="table-cell number-cell">{{ index + 1 }}</td>
                      
                      <td class="table-cell label-cell">
                        <v-text-field
                          :id="'label-field-popup' + (Adddialog ? 'add' : 'edit') + '-modelquickreply-' + index"
                          v-model="item.label"
                          variant="outlined"
                          density="compact"
                          hide-details
                          class="table-input"
                          :placeholder="Adddialog ? $t('Label') : $t('_quickReplyName')"
                        />
                      </td>
                      
                      <td class="table-cell label-cell">
                        <v-text-field
                          :id="'message-field-popup' + (Adddialog ? 'add' : 'edit') + '-modelquickreply-' + index"
                          v-model="item.data"
                          variant="outlined"
                          density="compact"
                          hide-details
                          class="table-input"
                          :placeholder="Adddialog ? $t('Message') : $t('_quickReplyData')"
                        />
                      </td>
                      
                      <td class="table-cell label-cell">
                        <v-autocomplete
                          :id="Adddialog ? ('type-autocomplete-popupadd-modelquickreply-' + index) : ('type-field-popupedit-modelquickreply-' + index)"
                          v-model="item.type"
                          :items="quickReplyType"
                          variant="outlined"
                          density="compact"
                          hide-details
                          class="table-autocomplete"
                          hide-no-data
                          width="165"
                          :placeholder="Adddialog ? $t('Type') : ''"
                        >
                          <template v-slot:item="{ props, item, index }">
                            <v-list-item 
                              v-bind="props"
                              :id="'type-' + (Adddialog ? 'add' : 'edit') + '-modelquickreply-option-' + index"
                              :value="item.raw"
                            >
                              <template v-slot:title>
                                <span>{{ item.raw }}</span>
                              </template>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                      </td>
                      
                      <td class="table-cell upload-cell">
                        <v-btn
                          :id="'button-upload-popup' + (Adddialog ? 'add' : 'edit') + '-modelquickreply-' + index"
                          color="#C32E0E"
                          variant="outlined"
                          size="small"
                          class="upload-btn"
                          @click="Click_FileButtonQuickReply(index)"
                        >
                          <v-img :src="images.iconcolImg" class="mr-2" width="16" height="16" alt="Upload"></v-img>
                          {{ $t("UploadImage") }}
                          <v-tooltip v-if="item.iconFileURL && item.iconFileURL !== ''" activator="parent" location="top">
                              {{ $t('changeIcon') }}
                          </v-tooltip>
                          <v-tooltip v-else activator="parent" location="top">
                              {{ $t('uploadIcon') }}
                            </v-tooltip>
                        </v-btn>
                      </td>
                      
                      <td class="table-cell preview-cell">
                        <div class="image-preview">
                          <div
                            class="preview-avatar"
                          >
                            <img
                              v-if="item.iconFileURL && item.iconFileURL !== ''"
                              :src="item.iconFileURL"
                              alt="Preview"
                            />
                            <v-img v-else :src="images.iconpreviewImg"></v-img>
                        </div>
                        </div>
                      </td>
                      
                      <td class="table-cell actions-cell">
                        <div class="action-buttons">
                          <v-btn
                            :id="Adddialog ? null : ('button-deleterowmodel-popupedit-modelquickreply-' + index)"
                            :disabled="index == 0 && GroupModel.commandList.length == 1"
                            icon
                            variant="text"
                            size="small"
                            color="error"
                            class="actionbtns removebtns mr-4"
                            @click="Minus_QuickReply(index)"
                          >
                            <v-icon size="30">mdi-minus</v-icon>
                            <v-tooltip activator="parent" location="top">
                              {{ $t('removeCommand') }}
                            </v-tooltip>
                          </v-btn>
                          
                          <v-btn
                            :id="'button-addrowmodel-popup' + (Adddialog ? 'add' : 'edit') + '-modelquickreply-' + index"
                            icon
                            variant="text"
                            size="small"
                            color="success"
                            class="actionbtns addbtn"
                            @click="Plus_QuickReply(index)"
                          >
                            <v-icon size="30">mdi-plus</v-icon>
                            <v-tooltip activator="parent" location="top">
                              {{ $t('addCommand') }}
                            </v-tooltip>
                          </v-btn>
                          
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </v-table>
              </div>
            </div>
          
          <!-- Hidden file input -->
          <input
            id="inputfileQuickReply"
            :aria-label="$t('uploadFile')"
            ref="bindFileNameQuickReply"
            type="file"
            @change="QuickReplyIcon"
            style="display: none"
            accept="image/png,image/jpeg"
          />
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="dialog-actions">
            <div class="actions-right">
              <v-btn
                variant="outlined"
                color="grey"
                @click="quickReplyDialog = false"
                class="dialog-action-btn cancel-btn"
              >
                {{ $t("cancel") }}
              </v-btn>

              <v-btn
                :id="'button-save-popup' + (Adddialog ? 'add' : 'edit') + '-modelquickreply'"
                variant="elevated"
                @click="Save"
                :class="['dialog-action-btn', Adddialog ? 'save-btn-add' : 'save-btn-edit']"
                :loading="dialog"
              >
                <v-img :src="images.saveImg" width="20" height="20" class="mr-2" />
                {{ $t("save") }}
              </v-btn>
            </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Details -->
    <v-dialog v-model="Detaildialog" max-width="600px">
      <v-card class="detail-dialog">
        <!-- Header -->
        <div class="dialog-header dialog-header-add">
          <div class="header-main">
            <div class="header-text-content">
              <div class="title-with-chip">
                <h2 class="dialog-title">{{ $t('viewDetails') }}</h2>
                <v-chip v-if="TempModel.length > 0" size="small" variant="tonal" class="summary-chip mb-2">
                  {{ TempModel.length }} {{ $t('models') }}
                </v-chip>
              </div>
              <p class="dialog-subtitle">{{ $t('_modelDetailsAndInfo') }}</p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn icon variant="text" @click="Detaildialog = false" class="close-button">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
        <!-- Dialog Content -->
        <v-card-text class="detail-content">
          <div class="models-container">
            <!-- Empty State -->
            <div v-if="TempModel.length === 0" class="empty-state">
              <v-icon size="64" color="grey-lighten-2">mdi-robot-off</v-icon>
              <div class="text-h6 text-grey-darken-1 mt-4">{{ $t('_noModelsFound') }}</div>
              <div class="text-body-2 text-grey">{{ $t('_noModelDataToDisplay') }}</div>
            </div>

            <!-- Model List -->
            <div v-else class="model-list">
              <div
                v-for="(item, index) in TempModel"
                :key="item.id"
                class="model-item"
                :class="{ 'last-item': index === TempModel.length - 1 }"
              >
                <div class="model-card">
                  <div class="model-content">
                    <div class="model-info">
                      <div class="model-icon-wrapper">
                        <v-img :src="images.modeldetailImg" width="20" height="20"></v-img>
                      </div>
                      <div class="model-details">
                        <h4 class="model-name">{{ item.name }}</h4>
                      </div>
                    </div>
                    
                    <div class="model-actions">
                      <v-btn
                        variant="outlined"
                        size="small"
                        class="view-btn"
                        @click="View(item)"
                      >
                        <v-icon size="16" class="mr-1">mdi-eye</v-icon>
                        {{ $t('view') }}
                      </v-btn>
                    </div>
                  </div>
                </div>
                
                <!-- Divider (except for last item) -->
                <v-divider
                  v-if="index < TempModel.length - 1"
                  class="model-divider"
                ></v-divider>
              </div>
            </div>
          </div>
        </v-card-text>

        <!-- Dialog Actions -->
        <v-card-actions class="detail-actions">
            <div class="actions-right">
              <v-btn
                variant="outlined"
                color="grey"
                @click="Detaildialog = false"
                class="control-btn create-btn customadd mr-0"
              >
              <v-icon class="mr-2">mdi-close</v-icon>
                {{ $t("close") }}
              </v-btn>
            </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Custom Delete Dialog -->
    <v-dialog v-model="dialog_delete" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="delete-dialog-title">{{ $t('deleteConfirmation') }}</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="delete-close-icon"
            @click="cancelDelete"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span v-if="deleteItem">
            {{ $t('_confirmDeleteModelShortcut') }}
          </span>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="delete-cancel-btn"
            @click="cancelDelete"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            class="delete-confirm-btn"
            @click="confirmDelete"
          >
            <v-img :src="images.deleteIcon" width="20" height="20" class="mr-2"/>
            {{ $t('delete') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Shortcut group import -->
    <v-dialog v-model="importDialog" max-width="600px" persistent>
      <v-card class="modern-dialog import-dialog">
        <!-- Header -->
        <v-card-title class="dialog-header import-header">
          <div class="header-content">
            <div class="header-left">
              <div class="header-icon">
                <v-icon size="28" color="white">mdi-download</v-icon>
              </div>
              <div class="header-text">
                <h2 class="dialog-title">{{ $t('importShortcutGroup') }}</h2>
                <p class="dialog-subtitle">{{ $t('_selectShortcutGroupToImport') }}</p>
              </div>
            </div>
            <div class="header-right">
              <v-btn
                icon
                variant="text"
                @click="importDialog = false"
                class="close-btn"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-title>

        <!-- Content -->
        <v-card-text class="dialog-content import-content">
          <div class="form-container">
            <div class="form-section">
              <div class="section-header">
                <v-icon size="20" color="primary" class="mr-2">mdi-folder-multiple-outline</v-icon>
                <h3 class="section-title">{{ $t('_selectShortcutGroup') }}</h3>
              </div>

              <div class="input-wrapper">
                <div class="input-label">
                  <span>{{ $t('_availableShortcutGroups') }}</span>
                  <span class="required-asterisk">*</span>
                  <InfoTooltip :text="$t('_chooseShortcutGroupToImport')"
                    size="small" color="grey-darken-1" icon-class="help-icon help-icon-accent" location="top" max-width="300px" />
                </div>
                
                <v-autocomplete
                  id="shortcutgroup-autocomplete-popupcopyimport-modelquickreply"
                  :items="QuickGroup"
                  v-model="importData"
                  :label="$t('_selectShortcutGroup')"
                  item-title="name"
                  item-value="modelQuickGroupID"
                  variant="outlined"
                  density="comfortable"
                  clearable
                  class="modern-input import-autocomplete"
                  hide-details="auto"
                  :placeholder="$t('_chooseShortcutGroupPlaceholder')"
                  prepend-inner-icon="mdi-folder-search-outline"
                >
                  <template v-slot:item="{ props, item, index }">
                    <v-list-item 
                      v-bind="props"
                      :id="'shortcutgroup-import-modelquickreply-option-' + index" 
                      :value="item.raw.name"
                    >
                      <template v-slot:title>
                        <span>{{ item.raw.name }}</span>
                      </template>
                    </v-list-item>
                  </template>
                  <template v-slot:append-inner>
                    <InfoTooltip :text="$t('_selectShortcutGroupToImport')"
                      size="small" color="grey-darken-1" icon-class="" location="top" max-width="300px" />
                  </template>
                </v-autocomplete>
              </div>
              
              <!-- Info Message -->
              <div class="info-message import-info">
                <v-icon size="16" color="info" class="mr-2">mdi-information-outline</v-icon>
                <span>{{ $t('_importingWillAddModels') }}</span>
              </div>
            </div>
          </div>
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="dialog-actions import-actions">
          <div class="actions-content">
            <div class="actions-left">
              <v-chip
                v-if="QuickGroup && QuickGroup.length > 0"
                size="small"
                variant="tonal"
                color="info"
                class="summary-chip"
              >
                <v-icon size="14" class="mr-1">mdi-folder-multiple</v-icon>
                {{ $t('_availableGroups', { count: QuickGroup.length }) }}
              </v-chip>
            </div>
            
            <div class="actions-right">
              <v-btn
                variant="outlined"
                color="grey"
                @click="importDialog = false"
                class="dialog-action-btn cancel-btn"
              >
                <v-icon class="mr-2">mdi-close</v-icon>
                {{ $t('cancel') }}
              </v-btn>

              <v-btn
                id="button-import-popupadd-modelquickreply"
                color="success"
                variant="elevated"
                @click="importDialogConfirm"
                class="dialog-action-btn import-btn-action"
                :disabled="!importData"
              >
                <v-icon class="mr-2">mdi-download</v-icon>
                {{ $t('import') }}
              </v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import checkPermissionTwo from "@/api/function.js";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
import viewdetailImg from "@/assets/images/eyedetail.svg";
import editBtn from '@/assets/images/editbutton.png';
import deleteBtn from '@/assets/images/trashbutton.png';
import modeldetailImg from '@/assets/images/modeldetail.svg';
import deleteIcon from "@/assets/images/trash-solid.svg";
import basicInfo from "@/assets/images/basicinfo.png";
import modelSetup from "@/assets/images/modelsetup.png";
import saveImg from '@/assets/images/savecard.png';
import uploadImg from '@/assets/images/uploadimg.png';
import previewImg from '@/assets/images/preview.png';
import quickReply from '@/assets/images/quickgroup.png';
import iconcolImg from '@/assets/images/iconcol.png';
import iconpreviewImg from '@/assets/images/iconpreview.png';
import InfoTooltip from "@/components/InfoTooltip.vue";
import ModelChipsCell from "@/components/ModelChipsCell.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import groupCrudCommonMixin from "@/mixins/groupCrudCommonMixin.js";
import quickGroupSourceMixin from "@/mixins/quickGroupSourceMixin.js";
import imageUploadHelpersMixin from "@/mixins/imageUploadHelpersMixin.js";
export default {
  name: "ModelQuickReply",
  components: { InfoTooltip, ModelChipsCell, LoadingOverlay },
  mixins: [checkPermissionTwo, groupCrudCommonMixin, quickGroupSourceMixin, imageUploadHelpersMixin],
  inject:['FontColorTitle','SubNavbarBackGround'],
  data: () => ({
    indexImportFile: null,
    uploadInputElementId: "inputfileQuickReply",

    importData: null,
    checkbox1: false,
    Editdialog: false,
    Adddialog: false,
    Detaildialog: false,
    dialog: false,
    loading: false,
    valid: true,
    tempID: 0,
    MenuID1: null,
    MenuID2: null,
    MenuID3: null,
    menuID: null,
    subMenuID: null,
    today: null,
    maxLengthChar: 0,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    rules: {
      required: (value) => !!value || "Required.",
    },
    DDGPTModel: [],
    headers_version_history: [],

    searchName: "",
    isSearch: false,
    isFirst: true,
    menus: [],
    QuickGroup: [],
    quickReplyType: ["postback", "message"],
    images: {
      edit: editImg,
      delete: deleteImg,
      viewdetailImg: viewdetailImg,
      editBtn: editBtn,
      deleteBtn: deleteBtn,
      modeldetailImg: modeldetailImg,
      deleteIcon: deleteIcon,
      basicInfo: basicInfo,
      modelSetup: modelSetup,
      saveImg: saveImg,
      uploadImg: uploadImg,
      previewImg: previewImg,
      quickReply: quickReply,
      iconcolImg: iconcolImg,
      iconpreviewImg: iconpreviewImg,
    },
    dialog_delete: false,
    deleteItem: null,
    GroupModel: {
      modelQuickGroupID: null,
      Name: null,
      Model: [],
      isAllModel: false,
      commandList: [
        {
          id: 0,
          label: null,
          data: null,
          type: null,
          modelQuickGroupID: null,
          iconFileURL: null,
          imgName: null,
        },
      ],
    },
    importDialog: false,
    TempModel: [],
    dialog_replace: false,
    replace_modelid: 0,
    replace_modelid_list: { id: 0, name: "x" },
    replace_modelid_lists: [], //{id:0, name: "x"}
    dialog_version: false,
    menus_version: [],
    menus_modeliddisplay_version: 0,
    searchTotalTable_version: 0,
    totalTable_version: 0,
    itemsPerPage_version: 5,
    sortBy: [],
    sortDesc: [],
  }),
  computed: {
    headers() {
      return [
        {
          title: this.$t("no"),
          align: "center",
          sortable: false,
          width: "95px",
        },
        {
          title: this.$t("quickReplyGroup"),
          align: "left",
          sortable: true,
          value: "Name",
        },
        {
          title: this.$t("modelName"),
          align: "left",
          sortable: false,
          value: "ModelNameTable",
        },
        { title: this.$t("manage"), align: "center", sortable: false, width: "150px" },
      ];
    },
    quickReplyDialog: {
      get() {
        return this.Adddialog || this.Editdialog;
      },
      set(val) {
        if (!val) {
          this.importData = null;
          this.Adddialog = false;
          this.Editdialog = false;
        }
      },
    },
    areDialogsClosed() {
      return !this.Adddialog && !this.Editdialog;
    },
    // Add this computed property
    filteredQuickGroup() {
      if (this.Editdialog && this.GroupModel.modelQuickGroupID) {
        // When editing, exclude the current group
        return this.QuickGroup.filter(
          group => group.modelQuickGroupID !== this.GroupModel.modelQuickGroupID
        );
      }
      // When adding, show all groups
      return this.QuickGroup;
    },
  },
  watch: {
    areDialogsClosed(newVal) {
      if (newVal) {
        this.CommandClear();
      }
    },
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handleImportSelection(value) {
      if (value) {
        this.importDialogConfirm();
      }
    },
    filteredModels(index) {
      const selectedModelIds = new Set(this.GroupModel.Model.filter(
        (_, idx) => idx !== index
      ).map((model) => model.modelID));

      return this.DDGPTModel.filter(
        (model) => !selectedModelIds.has(model.modelDisplayID)
      );
    },
    RedundantCheck(input) {
      const values = input
        .filter(
          (item) => item["modelID"] !== null && item["modelID"] !== undefined
        )
        .map((item) => item["modelID"]);
      const foundDuplicates = values.filter(
        (value, index, self) => self.indexOf(value) !== index
      );
      return foundDuplicates.length > 0;
    },
    importDialogShow() {
      this.importDialog = true;
    },
    importDialogConfirm() {
      if (this.GroupModel.isAllModel == false) { //NOSONAR
        this.QuickGroup.forEach((eachGroup) => {
          if (eachGroup.modelQuickGroupID === this.importData) {
            this.GetDDModelQuick(eachGroup.modelQuickGroupID);
            this.importDialog = false;
            this.GroupModel.Model = this.GroupModel.Model.filter(
              (model) => model.modelID !== null
            );
          }
        });
      } else {
        alert(this.$t("_allModelCannotImport"));
        this.importDialog = false;
      }
    },
    CommandClear() {
      this.importData = null;
      this.GroupModel.modelQuickGroupID = 0;
      this.GroupModel.commandList = [
        {
          id: 0,
          label: null,
          data: null,
          type: null,
          modelQuickGroupID: 0,
          iconFileURL: null,
          imgName: null,
        },
      ];
      this.GroupModel.Name = "";
      this.GroupModel.Model = null;
      this.GroupModel.isAllModel = false;
    },
    closeEditDialog() {
      this.importData = null;
      this.Editdialog = false;
    },
    closeAddDialog() {
      this.importData = null;
      this.Adddialog = false;
    },
    GetDDModelQuickReplyCommand(id) {
      this.$call.GetDDModelQuickReplyCommand(
        id,
        (dataResponse) => {
          if (dataResponse.status === 0) {
            this.GroupModel.commandList = dataResponse.data;
            this.GroupModel.modelQuickGroupID = id;
            this.loading = false;
          }
        },
        (errorResource) => {
          this.dialog = false;
          this.isSearch = false;
          this.loading = false;
          console.error(errorResource);
        }
      );
    },
    clearModel() {
      if (this.GroupModel.isAllModel) {
        this.GroupModel.Model = [];
      } else if (this.Adddialog) {
        this.GroupModel.Model = [
          {
            modelQuickID: null,
            name: "",
            modelID: null,
            modelQuickGroupID: null,
          },
        ];
      } else {
        this.GetModelGroupAndQuickReply(this.GroupModel.modelQuickGroupID);
      }
    },
    Search() {
      this.isSearch = true;
      this.options.page = 1;
      this.Get();
    },
    Get() {
      this.loadingTable = true;
      this.fetchServerTable(
        (temp, onSuccess, onError) => this.$call.GetQuickReplyGroup(temp, onSuccess, onError),
        {
          onSuccess: () => {
            this.GetDDGPTModel();
            this.loadingTable = false;
            this.isSearch = false;
            this.isFirst = false;
          },
          onError: () => {
            this.loadingTable = false;
            this.isSearch = false;
          },
        }
      );
    },
    confirmDelete() {
      if (!this.deleteItem) return;
      const id = this.deleteItem
      try {
              this.dialog = true;
              this.dialog_delete = false;

              this.$call.DeleteQuickReplyGroup(
                id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    this.$swal.fire({
                      title: this.$t("_successfullyDeleted"),
                      showConfirmButton: false,
                      timer: 1500,
                      position: 'top',
                      customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
                    });

                    this.Get();
                  }
                  this.dialog = false;
                },
                (errorResource) => {
                  this.dialog = false;
                  this.Adddialog = false;
                  console.error(errorResource);
                }
              );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    Add() {
      this.importData = null;
      this.GroupModel.modelQuickGroupID = null;
      this.GroupModel.Name = null;
      this.GroupModel.Model = [
        {
          modelQuickID: null,
          name: "",
          modelID: null,
          modelQuickGroupID: null,
        },
      ];

      this.GroupModel.isAllModel = false;
      this.Adddialog = true;
    },
    Edit(item) {
      this.importData = null;
      this.Editdialog = true;
      this.GroupModel.modelQuickGroupID = item.modelQuickGroupID;
      this.GroupModel.Name = item.name;
      this.GroupModel.Model = [];
      this.GroupModel.isAllModel = item.isAllModel;
      if (
        this.GroupModel.isAllModel == false || //NOSONAR
        this.GroupModel.isAllModel == null
      ) {
        this.GetModelGroupAndQuickReply(this.GroupModel.modelQuickGroupID);
      } else if (this.GroupModel.isAllModel == true) { //NOSONAR
        this.GetModelQuickCommand(this.GroupModel.modelQuickGroupID);
      }
    },
    async GetModelGroupAndQuickReply(_modelQuickGroupID) {
      try {
        this.dialog = true;
        await this.$call.GetModelGroupAndQuickReply(
          _modelQuickGroupID,
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              this.GroupModel.Model = dataResponse.data.groupList;
              this.GroupModel.commandList = dataResponse.data.quickReplyList;
            }

            if (this.GroupModel.Model.length == 0) {
              this.GroupModel.Model = [
                {
                  modelQuickID: null,
                  name: "",
                  modelID: null,
                  modelQuickGroupID: null,
                },
              ];
            }
            if (this.GroupModel.commandList.length == 0) {
              this.GroupModel.commandList = this.defaultCommandList();
            }
            this.dialog = false;
          },
          () => {
            this.dialog = false;
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    defaultCommandList() {
      return [
        {
          id: 0,
          label: null,
          data: null,
          type: null,
          createDate: null,
          createBy: null,
          updateDate: null,
          updateBy: null,
          modelQuickGroupID: null,
          iconFileURL: null,
          activeFlag: true,
        },
      ];
    },
    async GetModelQuickCommand(_modelQuickGroupID) {
      try {
        this.dialog = true;
        await this.$call.GetModelQuickCommand(
          _modelQuickGroupID,
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              this.GroupModel.commandList = dataResponse.data;
            }
            if (this.GroupModel.commandList.length == 0) {
              this.GroupModel.commandList = this.defaultCommandList();
            }
            this.dialog = false;
          },
          () => {
            this.dialog = false;
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    async GetDDModelQuick(_modelQuickGroupID) {
      try {
        this.dialog = true;
        await this.$call.GetDDModelQuick(
          { modelQuickGroupID: _modelQuickGroupID },
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              if (
                this.GroupModel.Model.length == 1 &&
                this.GroupModel.Model[0].modelID == null &&
                this.GroupModel.Model[0].modelQuickGroupID == null &&
                this.GroupModel.Model[0].name == ""
              ) {
                this.GroupModel.Model = dataResponse.data;
              } else {
                let tempGroup = this.GroupModel.Model;
                this.GroupModel.Model = this.GroupModel.Model.concat(
                  dataResponse.data
                );
                if (this.RedundantCheck(this.GroupModel.Model)) {
                  this.dialog = false;
                  alert(this.$t("_noDuplicatedModels"));
                  this.GroupModel.Model = tempGroup;
                  this.importDialog = false;
                  return;
                }
              }
            }

            if (this.GroupModel.Model.length == 0 && dataResponse.data.length) {
              this.GroupModel.Model = [
                {
                  modelQuickID: null,
                  name: "",
                  modelID: null,
                  modelQuickGroupID: null,
                },
              ];
            }

            this.dialog = false;
          },
          () => {
            this.dialog = false;
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },

    Detail(item) {
      this.TempModel = [];
      this.Detaildialog = true;
      this.GroupModel.modelQuickGroupID = item.modelQuickGroupID;
      this.GroupModel.Name = item.name;
      this.GroupModel.Model = item.modelId;
      let dataLoop = item.modelName.split(", ");
      for (const element of dataLoop) {
        const name = element;
        const id = name.split(":")[1];
        let temp = {
          name: name.split(":")[0],
          id: id,
        };
        this.TempModel.push(temp);
      }
    },
    Clear() {
      this.GroupModel.modelQuickGroupID = null;
      this.GroupModel.commandList = null;
      this.GroupModel.Name = null;
      this.GroupModel.Model = null;
      this.GroupModel.isAllModel = false;
      this.Editdialog = false;
      this.Adddialog = false;
    },
    async Save() {
      try {
        if (
          this.GroupModel.Name == "" ||
          this.GroupModel.Name == null ||
          (this.GroupModel.isAllModel == false && //NOSONAR
            this.GroupModel.Model.some((s) => !s.modelID))
        ) {
          this.$swal.fire({
            icon: "warning",
            title: this.$t("warning"),
            text: this.$t("warningFillAll"),
            showConfirmButton: false,
            timer: 1800,
          });
          return;
        }
        if (
          this.GroupModel.commandList.some(
            (x) => !x.label || !x.data || !x.type
          )
        ) {
          this.$swal.fire({
            icon: "warning",
            title: this.$t("warning"),
            text: this.$t("warningFillAll"),
            showConfirmButton: false,
            timer: 1800,
          });
          return;
        }

        this.dialog = true;
        if (this.Adddialog) {
          await this.$call.CreateQuickReplyGroup(
            this.GroupModel,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                this.$swal.fire({
                  title: this.$t("_quickReplyGroupCreated") + dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                  backdrop: false,
                  position: 'top',
                  customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title'
                  },
                });
                this.totalTable = this.totalTable + 1;
                this.Get();
                this.CommandClear();
                this.Adddialog = false;
              } else if (dataResponse.status == 3) {
                this.$swal.fire({
                  icon: "warning",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 2000,
                });
              }
              this.dialog = false;
            },
            (errorResource) => {
              this.dialog = false;
              console.error(errorResource);
            }
          );
        } else if (this.Editdialog) {
          await this.$call.UpdateModelQuickReply(
            this.GroupModel,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                this.$swal.fire({
                  title: this.$t("_shortcutMenuUpdatedPrefix") + dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                  backdrop: false,
                  position: 'top',
                  customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title'
                  },
                });
                this.Get();
                this.CommandClear();
                this.Editdialog = false;
              } else if (dataResponse.status == 3) {
                this.$swal.fire({
                  icon: "warning",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 2000,
                });
              }
              this.dialog = false;
            },
            (errorResource) => {
              this.dialog = false;
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },

    UploadImage() {
      if (!this.requestUpload.entity) {
        alert(this.$t("_pleaseFillAllFields"));
        return;
      }

      this.requestUpload.USER_CHANNEL = this.$root.User_Id;

      this.loadingImage = true;
      try {
        this.$call.UploadImageModelQuick(
          this.requestUpload,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              /* success: no action needed */
            } else {
              this.$swal.fire({
                icon: "error",
                title: this.$t("errorUploadImage"),
                showConfirmButton: false,
                timer: 2500,
              });
              this.ClearImage();
            }
            this.loadingImage = false;
          },
          (errorResource) => {
            this.$swal.fire({
              icon: "error",
              title: this.$t("errorUploadImage"),
              showConfirmButton: false,
              timer: 2500,
            });
            this.loadingImage = false;
            this.ImageURL = null;
            this.fileDataUrl = null;
            this.requestUpload.entity = null;
            console.error(errorResource);
          }
        );
      } catch (error) { //NOSONAR
        // error intentionally ignored — no rethrow required
        this.GetTopicStream("Start");

        console.log("catch : DeleteGroup");
      }
    },

    Plus_ModelQuick(index) {
      this.GroupModel.Model.splice(index + 1, 0, {
        modelQuickID: null,
        name: "",
        modelID: null,
        modelQuickGroupID: null,
      });
    },
    Minus_ModelQuick(index) {
      this.GroupModel.Model.splice(index, 1);
    },
    Plus_QuickReply(index) {
      this.GroupModel.commandList.splice(index + 1, 0, {
        id: 0,
        label: null,
        data: null,
        type: null,
        createDate: null,
        createBy: null,
        updateDate: null,
        updateBy: null,
        modelQuickGroupID: null,
        iconFileURL: null,
        activeFlag: true,
      });
    },
    Minus_QuickReply(index) {
      this.GroupModel.commandList.splice(index, 1);
    },

    Click_FileButtonQuickReply(_indexImportFile) {
      this.clickUploadFileButton(_indexImportFile);
    },

    QuickReplyIcon(e_para) {
      try {
        this.dialog = true;
        const file = this.getSelectedUploadFile(e_para);

        if (!file) {
          this.dialog = false;
          this.showUploadError("Something went wrong!");
          return;
        }

        if (!this.isSupportedUploadImage(file) || !this.hasUploadFileExtension(file)) {
          this.clearUploadError(this.$t("_onlyJpegPngFiles"));
          return;
        }

        this.loadUploadImage(file, (dataurl) => {
          this.GroupModel.commandList[this.indexImportFile].iconFileURL = dataurl;
          this.GroupModel.commandList[this.indexImportFile].imgName = file.name;
          this.resetUploadFileInput();
          this.dialog = false;
        });
      } catch {
        this.clearUploadError(this.$t("_somethingWentWrong"));
      }
    },
  },
  mounted() {
    this.GetDate();
    this.GetQuickGroup();
  },
};
</script>
<style scoped>

.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
}

.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0;
  padding: 0;
}

textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
/*#region Details Dialog*/

/* Dialog Base Styles */
/* .modern-dialog, */
.detail-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
  max-height: 85vh;
}

/* Dialog Headers */

.detail-header {
  background: linear-gradient(135deg, #2f6ea5 0%, #285f96 100%);
  color: white;
  padding: 24px !important;
  border-bottom: none;
}

.header-content,
.detail-header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

.header-left {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.header-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dialog-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  color: white;
  letter-spacing: 0.025em;
}

.detail-title {
  font-size: 1.4rem;
  font-weight: 700;
  margin: 0;
  color: white;
  letter-spacing: 0.025em;
}

/* .dialog-subtitle, */
.detail-subtitle {
  font-size: 0.85rem;
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 400;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* .close-btn, */
.detail-close-btn {
  background: rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

/* .close-btn:hover, */
.detail-close-btn:hover {
  background: rgba(255, 255, 255, 0.2) !important;
  transform: scale(1.05);
}

.count-chip {
  background: #e9f5fe !important;
  color: #0d47a1 !important;
  font-weight: 600;
  backdrop-filter: blur(10px);
}

/* Dialog Content */
.dialog-content {
  padding: 32px !important;
  background: #ffffff;
  max-height: 70vh;
  overflow-y: auto;
}

.detail-content {
  padding: 0 !important;
  background: #fafafa;
  max-height: 50vh;
  overflow-y: auto;
}

.models-container {
  padding: 24px;
}

/* Model List and Cards */
.model-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.model-item {
  position: relative;
}

.model-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  width: 100%;
  border: 1px solid var(--Field-border, #C9C9C9);
}

.model-card:hover {
  border-color: rgba(74, 144, 226, 0.2);
  box-shadow: 0 8px 25px rgba(74, 144, 226, 0.15);
  transform: translateY(-2px);
}

.model-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 16px;
}

.model-info {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  min-width: 0;
}

.model-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  border: 1px solid rgba(195, 46, 14, 0.25);
  background: rgba(195, 46, 14, 0.10);
  flex-shrink: 0;
}

.model-details {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.model-name {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  letter-spacing: 0.025em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.2;
}

.model-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
  align-items: center;
}

.view-btn {
  border-radius: 10px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.025em;
  transition: all 0.3s ease;
  min-width: 80px;
  height: 36px;
  white-space: nowrap;
  border: 1px solid var(--main, #C32E0E);
  color: #C32E0E;
}

.view-btn:hover {
  background: #FDE4DF !important;
  transform: scale(1.05);
}

.model-divider {
  margin: 10px 0;
  border-color: rgba(74, 144, 226, 0.9);
}
/* Dialog Actions */
/* .dialog-actions, */
.detail-actions {
  padding: 20px 24px !important;
  background: white;
  border-top: 1px solid #e9ecef;
}

/* .actions-content, */
.detail-actions-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.actions-left {
  display: flex;
  align-items: center;
}

.actions-right {
  display: flex;
  gap: 12px;
}

/* Buttons */

.detail-action-btn {
  height: 40px;
  border-radius: 12px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.025em;
  transition: all 0.3s ease;
  min-width: 100px;
}

/* .cancel-btn, */
.close-action-btn {
  border: 2px solid #dee2e6 !important;
  color: #6c757d !important;
}

/* .cancel-btn:hover, */
.close-action-btn:hover {
  border-color: #adb5bd !important;
  background: #f8f9fa !important;
  transform: translateY(-1px);
}

/* Scrollbar Styling */
.dialog-content::-webkit-scrollbar,
.detail-content::-webkit-scrollbar {
  width: 6px;
}

.dialog-content::-webkit-scrollbar-track,
.detail-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb,
.detail-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb:hover,
.detail-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Animations */
@media (prefers-reduced-motion: no-preference) {
  /* .modern-dialog, */
  .detail-dialog {
    animation: dialogSlideIn 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  }
  
  @keyframes dialogSlideIn {
    from {
      opacity: 0;
      transform: translateY(-30px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
  
  .model-card {
    animation: modelCardFadeIn 0.3s ease forwards;
  }
  
  @keyframes modelCardFadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
}
/*#endregion Details Dialog*/

/* Modern Dialog Styles */

/* Dialog Header */

/* Dialog Content */

.form-container {
  background: white;
  border-radius: 16px;
  padding: 15px;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.form-section {
  margin-bottom: 0px;
}

.form-section:last-child {
  margin-bottom: 0;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
}

.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  color: #171717;
  letter-spacing: 0.025em;
}

/* Input Styling */
.input-wrapper {
  margin-bottom: 20px;
}

.input-label {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-weight: 600;
  color: #424242;
  font-size: 0.9rem;
  gap: 4px;
}

.required-asterisk {
  color: #d32f2f;
  font-weight: 700;
}

.help-icon {
  cursor: help;
  transition: all 0.2s ease;
  opacity: 0.7;
}

.help-icon:hover {
  opacity: 1;
  color: #1976d2 !important;
  transform: scale(1.1);
}

.modern-input :deep(.v-field) {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.modern-input :deep(.v-field:hover) {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.modern-input :deep(.v-field--focused) {
  box-shadow: 0 4px 16px rgba(25, 118, 210, 0.2);
}

/* Checkbox Styling */
.checkbox-wrapper {
  padding: 0px 12px;
  border-radius: 12px;
  border: 1px solid var(--Field-border, #C9C9C9);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #424242;
}

/* Import Button */
.import-btn {
  width: 100%;
  border-radius: 12px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.025em;
  transition: all 0.3s ease;
  height: 44px;
}

.import-btn:hover {
  background: #1976d2 !important;
  color: white !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(25, 118, 210, 0.3) !important;
}

/* Table Styling */
.table-container {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
  margin-bottom: 16px;
}

.modern-table {
  background: white;
}

.table-header {
  background: #FFE4E1 !important;
  font-weight: 600 !important;
  font-size: 0.875rem !important;
  text-transform: none;
  letter-spacing: 0.5px;
  padding: 16px 12px !important;
}

.model-col {
  min-width: 200px;
}

.actions-col {
  width: 140px;
}

.table-row {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.table-row:hover {
  background: rgba(25, 118, 210, 0.02);
}

.table-cell {
  padding: 12px !important;
  vertical-align: middle;
}

.number-cell {
  text-align: start;
  font-weight: 600;
  color: #666;
}

.model-cell {
  min-width: 150px;
  max-width: 200px;
}
.label-cell{
  min-width: 180px!important;
}
.upload-cell,
.preview-cell {
  text-align: center;
}

.actions-cell {
  text-align: center;
}

/* Table Components */
.table-autocomplete :deep(.v-field),
.table-input :deep(.v-field) {
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.table-autocomplete :deep(.v-field:hover),
.table-input :deep(.v-field:hover) {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.table-autocomplete :deep(.v-autocomplete__menu-icon) {
  color: #872612;
  font-size: 32px;
  opacity: 1;
}

.upload-btn {
  border-radius: 8px !important;
  font-weight: 500;
  text-transform: none;
  white-space: nowrap;
  min-width: auto;
}

.image-preview {
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-avatar {
  border: 2px solid #C9C9C9;
  transition: all 0.3s ease;
  padding: 10px;
  border-radius: 12px;
  width: 50px;
  height: 50px;
  margin: auto;
}

.preview-avatar.has-image {
  border-color: #1976d2;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.2);
}

.preview-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.action-buttons {
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
}

.dialog-action-btn {
  transition: all 0.2s ease;
}

.dialog-action-btn:hover {
  transform: scale(1.1);
}

/* Info Messages */
.info-message {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: #edf7fe;
  border-radius: 8px;
  border-left: 4px solid #2196f3;
  font-size: 0.875rem;
  color: #0d47a1;
  margin-top: 16px;
}

.all-model-info {
  text-align: left;
  padding: 20px;
  border-radius: 16px;
  background: rgba(42, 191, 86, 0.10);
}

.info-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: #2ABF56;
  align-items: center!important;
}

.info-subtitle {
  font-size: 16px;
  margin: 0;
  color: #646464;
  opacity: 0.8;
}

/* Dialog Actions */

/* Scrollbar Styling */
.dialog-content::-webkit-scrollbar {
  width: 6px;
}

.dialog-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Responsive */
@media (max-width: 900px) {
  .dialog-header {
    padding: 20px 24px !important;
  }
  
  .dialog-content {
    padding: 24px !important;
  }
  
  .form-container {
    padding: 20px;
  }
  
  .table-container {
    overflow-x: auto;
  }
  
  .modern-table {
    min-width: 800px;
  }
  
  .dialog-actions {
    padding: 20px 24px !important;
    flex-direction: column-reverse;
    gap: 16px;
  }
  
  .actions-content {
    flex-direction: column-reverse;
    gap: 16px;
    width: 100%;
  }
  
  .actions-right {
    width: 100%;
    flex-direction: column;
  }
  
  .dialog-action-btn {
    width: 100%;
  }
}

/* Animations */
@media (prefers-reduced-motion: no-preference) {
  .modern-dialog {
    animation: dialogSlideIn 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  }
  
  @keyframes dialogSlideIn {
    from {
      opacity: 0;
      transform: translateY(-30px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
}
/* Add Model Section */
.add-model-section {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  transition: all 0.3s ease;
}

.add-model-btn {
  border-radius: 12px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.025em;
  transition: all 0.3s ease;
  min-width: 160px;
  height: 44px;
  border: 2px solid #4caf50 !important;
}

.add-model-btn:hover {
  background: #2e7d32 !important;
  color: white !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(76, 175, 80, 0.3) !important;
}

/* Import Dialog Specific Styles */
.import-dialog {
  max-width: 600px !important;
  animation: importDialogSlideIn 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.import-header {
  background: linear-gradient(135deg, #00acc1 0%, #0097a7 100%);
}

.import-content {
  padding: 28px !important;
  background: #fafafa;
  max-height: none;
  overflow: visible;
}

.import-autocomplete :deep(.v-field) {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  background: white;
}

.import-autocomplete :deep(.v-field:hover) {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #00acc1 !important;
}

.import-autocomplete :deep(.v-field--focused) {
  box-shadow: 0 4px 16px rgba(0, 172, 193, 0.2);
  border-color: #00acc1 !important;
}

.import-autocomplete :deep(.v-field--focused .v-field__outline) {
  border-color: #00acc1 !important;
  border-width: 2px;
}

.import-autocomplete :deep(.v-label--active) {
  color: #00acc1 !important;
}

.import-autocomplete :deep(.v-autocomplete__menu-icon) {
  color: #872612;
  font-size: 32px;
  opacity: 1;
}

.import-info {
  background: #ebf8fa;
  border-left: 4px solid #00acc1;
  color: #003c3e;
  margin-top: 16px;
}

.import-actions {
  padding: 24px 28px !important;
  background: white;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.import-btn-action {
  background: linear-gradient(135deg, #2e7d32 0%, #1b5e20 100%) !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3) !important;
}

.import-btn-action:hover {
  background: linear-gradient(135deg, #43a047 0%, #2e7d32 100%) !important;
  box-shadow: 0 6px 16px rgba(76, 175, 80, 0.4) !important;
  transform: translateY(-1px);
}

.import-btn-action:disabled {
  background: #e0e0e0 !important;
  color: #595959 !important;
  box-shadow: none !important;
  transform: none !important;
}

/* Enhanced Input Styling for Import */
.import-autocomplete :deep(.v-input__prepend-inner) {
  padding-top: 12px;
}

.import-autocomplete :deep(.v-field__input) {
  padding-left: 8px;
}

.import-autocomplete :deep(.v-input__append-inner) {
  padding-top: 12px;
}

/* Animation for Import Dialog */
@keyframes importDialogSlideIn {
  from {
    opacity: 0;
    transform: translateY(-30px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Enhanced Summary Chip for Import */
.import-actions .summary-chip {
  background: #e6f7f9 !important;
  color: #003c3e !important;
  font-weight: 600;
}

/* Responsive for Import Dialog */
@media (max-width: 600px) {
  .import-dialog {
    max-width: 95vw !important;
    margin: 16px;
  }
  
  .import-content {
    padding: 20px !important;
  }
  
  .import-actions {
    padding: 20px !important;
    flex-direction: column-reverse;
    gap: 16px;
  }
  
  .actions-content {
    flex-direction: column-reverse;
    gap: 16px;
    width: 100%;
  }
  
  .actions-right {
    width: 100%;
    flex-direction: column;
  }
  
  .dialog-action-btn {
    width: 100%;
  }
}
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
:deep(thead) {
  background-color: #FFE4E1 !important;
  padding: 0 8px;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
</style>
